/*
 * Sterntaler Lookbook – Produkt-Pop-up
 * Ein gemeinsames Modal für alle Lookbook-Hotspots (Stil analog Gratisartikel-Modal / PDP).
 * Produktdaten kommen pro Hotspot als <script type="application/json" id="lb-...">.
 *
 * PDP-Logiken, die hier gespiegelt werden:
 *  - Bild-Fit: Dateiname endet auf "_model" -> cover, sonst (Freisteller) -> contain
 *  - Farbkachel: ist das Variantenbild ein "_model"-Bild, wird das passende "<name>_M"-Bild gezeigt
 *  - Bildgruppe je Variante: Variantenbild + alle folgenden Bilder bis zum nächsten Variantenbild
 *    (wie der StarApps-Nachbau auf der PDP)
 *  - Größen in fester Sterntaler-Reihenfolge, als Pills
 *  - Farben ohne verfügbare Variante werden ausgeblendet
 *  - Bestandsanzeige wie snippets/stock-status.liquid (>10 "Sofort versandfertig", 1–10 "Nur noch X auf Lager")
 */
(function () {
  if (window.SterntalerLookbookPopupInit) return;
  window.SterntalerLookbookPopupInit = true;

  var COLOR_RE = /^(farbe|color|colour|couleur|kleur|colore)$/i;
  var SIZE_ORDER = '44,50,56,62,68,74,50/56,62/68,74/80,80,86,86/92,92,98,98/104,104,110,110/116,116,122,122/128,128,134,134/140,140,146,146/152,152,158,158/164,164,170,170/176,176,13/14,15/16,17/18,19/20,21/22,23/24,25/26,27/28,29/30,31/32,33/34,35/36,37/38,39/40'.split(',');
  var modal, dialog, lastTrigger, state;

  /* ---------------- Helpers ---------------- */
  function cfg() { return window.SterntalerLookbookConfig || {}; }

  function money(cents) {
    var c = cfg();
    try {
      return new Intl.NumberFormat(c.locale || document.documentElement.lang || 'de', {
        style: 'currency',
        currency: c.currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function icon(path, size) {
    var s = size || 16;
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }

  function isModelImage(m) { return !!m && /_model$/.test(m.name || ''); }

  /* EU AI Act: gleiche Erkennung wie snippets/sterntaler-ai-image-badge.liquid
     (Dateiname ohne Endung, an "_" und "-" zerlegt, enthält Token "model" oder "ki") */
  function isAiImage(m) {
    if (!m || !m.name) return false;
    var tokens = m.name.toLowerCase().replace(/-/g, '_').split('_');
    return tokens.indexOf('model') !== -1 || tokens.indexOf('ki') !== -1;
  }

  /* Optionsnamen wie auf der PDP normalisieren (snippets/product-variant-picker.liquid):
     "Color" bzw. Bundle-Name "Titel (Color)" -> Farbe, "Titel (Größe)" -> Größe */
  function optionKey(name) {
    var n = String(name || '').trim();
    var m = n.match(/\(([^)]+)\)\s*$/);
    var inner = (m ? m[1] : n).trim().toLowerCase();
    if (COLOR_RE.test(inner)) return 'color';
    if (/^(size|größe|grösse|groesse)$/.test(inner)) return 'size';
    return null;
  }
  function optionLabel(name) {
    var k = optionKey(name);
    if (k === 'color') return cfg().colorLabel || 'Farbe';
    if (k === 'size') return 'Größe';
    return name;
  }

  /* ---------------- Modal-Grundgerüst (einmalig) ---------------- */
  function buildModal() {
    if (modal) return;
    modal = el('div', 'lbp-modal');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="lbp-modal__backdrop" data-lbp-close></div>' +
      '<div class="lbp-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="lbp-title" tabindex="-1">' +
        '<span class="lbp-modal__grabber" aria-hidden="true"></span>' +
        '<button type="button" class="lbp-modal__close" data-lbp-close aria-label="Schließen">' +
          icon('<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>') +
        '</button>' +
        '<div class="lbp-modal__body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    dialog = modal.querySelector('.lbp-modal__dialog');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-lbp-close]')) { e.preventDefault(); close(); }
    });

    // Swipe-down zum Schließen (Bottom-Sheet mobil) – nicht auf der Thumbnail-Leiste
    var startY = null;
    dialog.addEventListener('touchstart', function (e) {
      if (dialog.scrollTop > 0 || e.target.closest('.lbp-thumbs')) { startY = null; return; }
      startY = e.touches[0].clientY;
    }, { passive: true });
    dialog.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      var dy = e.touches[0].clientY - startY;
      if (dy > 0) dialog.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    dialog.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      dialog.style.transform = '';
      startY = null;
      if (dy > 110) close();
    });
  }

  /* ---------------- Medien-Logik ---------------- */
  function mediaById(p, id) {
    for (var i = 0; i < p.media.length; i++) if (p.media[i].id === id) return p.media[i];
    return null;
  }

  function variantMediaIds(p) {
    var ids = [];
    p.variants.forEach(function (v) { if (v.media && ids.indexOf(v.media) === -1) ids.push(v.media); });
    return ids;
  }

  // Variantenbild + alle folgenden Bilder bis zum nächsten Variantenbild
  function mediaGroup(p, variant) {
    if (!p.media || !p.media.length) return [];
    if (!variant || !variant.media) return [p.media[0]];
    var start = -1;
    for (var i = 0; i < p.media.length; i++) if (p.media[i].id === variant.media) { start = i; break; }
    if (start === -1) return [p.media[0]];
    var stops = variantMediaIds(p);
    var group = [p.media[start]];
    for (var j = start + 1; j < p.media.length; j++) {
      if (stops.indexOf(p.media[j].id) !== -1) break;
      group.push(p.media[j]);
    }
    return group;
  }

  // Bild für die Farbkachel: bei "_model" das passende "_M"-Bild
  function swatchMedia(p, variant) {
    var m = variant && variant.media ? mediaById(p, variant.media) : null;
    if (!m) return null;
    if (isModelImage(m)) {
      var target = m.name.replace(/_model$/, '') + '_M';
      for (var i = 0; i < p.media.length; i++) if (p.media[i].name === target) return p.media[i];
    }
    return m;
  }

  /* ---------------- Varianten-Logik ---------------- */
  function colorIndex(p) {
    for (var i = 0; i < p.options.length; i++) if (optionKey(p.options[i]) === 'color') return i;
    return -1;
  }

  function uniqueValues(p, idx) {
    var out = [];
    p.variants.forEach(function (v) {
      var val = v.options[idx];
      if (val != null && out.indexOf(val) === -1) out.push(val);
    });
    if (idx === colorIndex(p)) {
      // wie PDP: Farben ohne verfügbare Variante ausblenden
      return out.filter(function (val) {
        return p.variants.some(function (v) { return v.available && v.options[idx] === val; });
      });
    }
    // Größen in fester Sterntaler-Reihenfolge, Unbekanntes hinten anhängen
    var known = SIZE_ORDER.filter(function (s) { return out.indexOf(s) !== -1; });
    if (!known.length) return out;
    return known.concat(out.filter(function (v) { return known.indexOf(v) === -1; }));
  }

  // Ist Wert "val" für Option "idx" verfügbar – unter Berücksichtigung der übrigen gewählten Optionen?
  function isAvailable(p, idx, val, sel) {
    return p.variants.some(function (v) {
      if (!v.available || v.options[idx] !== val) return false;
      for (var i = 0; i < sel.length; i++) {
        if (i === idx || sel[i] == null) continue;
        if (v.options[i] !== sel[i]) return false;
      }
      return true;
    });
  }

  function currentVariant() {
    var p = state.product, sel = state.selection;
    if (sel.some(function (s) { return s == null; })) return null;
    return p.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    }) || null;
  }

  // Referenzvariante für Bild/Preis, auch wenn noch nicht alles gewählt ist
  function previewVariant() {
    var p = state.product, sel = state.selection;
    return currentVariant() || p.variants.find(function (v) {
      return v.available && v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
    }) || p.variants.find(function (v) { return v.id === p.selectedVariant; }) || p.variants[0];
  }

  /* ---------------- Rendern ---------------- */
  function renderMedia(p, pv) {
    var wrap = el('div', 'lbp-gallery');
    var group = mediaGroup(p, pv);
    if (!group.length) group = [{ id: 0, name: '', src: p.image, thumb: p.image, alt: p.imageAlt }];

    // aktives Bild: bleibt erhalten, solange es zur aktuellen Gruppe gehört
    var active = group.find(function (m) { return m.id === state.activeMedia; }) || group[0];
    state.activeMedia = active.id;

    var main = el('a', 'lbp-media' + (isModelImage(active) ? ' lbp-media--cover' : ''));
    main.href = p.url;
    var img = el('img', 'lbp-media__img');
    img.src = active.src;
    img.alt = active.alt || p.title;
    main.appendChild(img);
    if (isAiImage(active) && cfg().aiBadgeHtml) main.insertAdjacentHTML('beforeend', cfg().aiBadgeHtml);
    wrap.appendChild(main);

    if (group.length > 1) {
      var thumbs = el('div', 'lbp-thumbs');
      thumbs.setAttribute('aria-label', 'Weitere Bilder');
      group.forEach(function (m, i) {
        var b = el('button', 'lbp-thumb' + (isModelImage(m) ? ' lbp-thumb--cover' : '') + (m.id === active.id ? ' is-active' : ''));
        b.type = 'button';
        b.dataset.lbpMedia = m.id;
        b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' anzeigen');
        if (m.id === active.id) b.setAttribute('aria-current', 'true');
        var t = el('img');
        t.src = m.thumb; t.alt = ''; t.loading = 'lazy';
        b.appendChild(t);
        thumbs.appendChild(b);
      });
      wrap.appendChild(thumbs);
    }
    return wrap;
  }

  function renderStock(v) {
    var p = el('p', 'stock-status lbp-stock');
    if (!v || !v.available || !v.tracked || v.qty <= 0) { p.hidden = true; return p; }
    if (v.qty > 10) { p.classList.add('stock-status--ok'); p.textContent = 'Sofort versandfertig'; }
    else { p.classList.add('stock-status--low'); p.textContent = 'Nur noch ' + v.qty + ' auf Lager'; }
    return p;
  }

  /* ---------------- PDP-Extras (Badges, Maßtabelle, Größenberater) ----------------
     Werden per /products/<handle>?view=lookbook-extras geladen – dieselben Snippets wie auf der PDP. */
  var extrasCache = {};
  var injectedStyles = [];

  function injectStyles(doc) {
    doc.querySelectorAll('style').forEach(function (st) {
      var css = st.textContent;
      if (injectedStyles.indexOf(css) !== -1) return;
      injectedStyles.push(css);
      var n = document.createElement('style');
      n.textContent = css;
      document.head.appendChild(n);
    });
  }

  // modal-opener/-dialog nicht übernehmen (würden sich sonst an den <body> hängen) – nur den Button
  function unwrapOpener(node, view) {
    node.querySelectorAll('modal-opener').forEach(function (op) {
      var btn = op.querySelector('button');
      if (!btn) { op.remove(); return; }
      btn.type = 'button';
      btn.removeAttribute('name');
      btn.setAttribute('data-lbp-view', view);
      var span = document.createElement('span');
      span.className = op.className.replace('no-js-hidden', '').trim();
      span.appendChild(btn);
      op.replaceWith(span);
    });
    node.querySelectorAll('modal-dialog').forEach(function (d) { d.remove(); });
    return node;
  }

  function parseExtras(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector('[data-lbx-root]')) return null;
    injectStyles(doc);
    var out = {};
    var assets = doc.querySelector('[data-lbx-assets]');
    try { out.assets = assets ? JSON.parse(assets.textContent) : {}; } catch (e) { out.assets = {}; }

    var badges = doc.querySelector('[data-lbx-badges]');
    if (badges && badges.querySelector('.flex-box > *')) {
      badges.querySelectorAll('style').forEach(function (x) { x.remove(); });
      out.badges = document.importNode(badges, true);
      out.badges.className = 'lbp-badges';
      out.badges.removeAttribute('data-lbx-badges');
    }

    var hint = doc.querySelector('[data-lbx-sizehint]');
    if (hint) out.sizeHint = document.importNode(hint, true);

    var sc = doc.querySelector('[data-lbx-sizechart]');
    if (sc) {
      var chartContent = sc.querySelector('modal-dialog .product-popup-modal__content-info');
      if (chartContent) out.chartPanel = document.importNode(chartContent, true);
      sc.querySelectorAll('style').forEach(function (x) { x.remove(); });
      out.chartLink = document.importNode(unwrapOpener(sc, 'chart'), true);
      out.chartLink.className = 'lbp-sizelink';
    }

    var sg = doc.querySelector('[data-lbx-sizeguide]');
    if (sg) {
      var guideContent = sg.querySelector('modal-dialog .size-guide-content');
      if (guideContent) out.guidePanel = document.importNode(guideContent, true);
      var h = sg.querySelector('.size-guide-hint');
      if (h) out.guideHint = document.importNode(unwrapOpener(h, 'guide'), true);
    }
    return out;
  }

  function loadExtras(p) {
    if (!p || !p.extrasUrl) return Promise.resolve(null);
    if (!extrasCache[p.extrasUrl]) {
      extrasCache[p.extrasUrl] = fetch(p.extrasUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return html ? parseExtras(html) : null; })
        .catch(function () { return null; });
    }
    return extrasCache[p.extrasUrl];
  }

  // Größenberater-Script (sterntaler-size-finder.js) einmalig für den eingefügten Finder initialisieren
  function initSizeFinder(panel, extras) {
    if (!panel || panel.dataset.lbpInit) return;
    panel.dataset.lbpInit = '1';
    if (!panel.querySelector('[data-size-finder]')) return;
    if (window.SterntalerSizeFinderInit) {
      // Script ist schon geladen -> dessen init() erneut anstoßen (nur dieser Finder ist gerade im DOM)
      document.dispatchEvent(new CustomEvent('shopify:section:load'));
    } else if (extras.assets && extras.assets.sizeFinderJs) {
      var sc = document.createElement('script');
      sc.src = extras.assets.sizeFinderJs;
      document.head.appendChild(sc);
    }
  }

  function renderPanel(p) {
    var body = modal.querySelector('.lbp-modal__body');
    body.innerHTML = '';
    var ex = state.extras || {};
    var panelNode = state.view === 'guide' ? ex.guidePanel : ex.chartPanel;

    var wrap = el('div', 'lbp-panel');
    var back = el('button', 'lbp-back');
    back.type = 'button';
    back.setAttribute('data-lbp-back', '');
    back.innerHTML = icon('<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>', 14) + '<span>Zurück zum Artikel</span>';
    wrap.appendChild(back);
    var inner = el('div', 'lbp-panel__content' + (state.view === 'chart' ? ' lbp-panel__content--chart' : ''));
    if (panelNode) inner.appendChild(panelNode);
    wrap.appendChild(inner);
    body.appendChild(wrap);
    dialog.scrollTop = 0;
    if (state.view === 'guide') initSizeFinder(panelNode, ex);
  }

  function render() {
    var p = state.product;
    if (state.view) { renderPanel(p); return; }
    var body = modal.querySelector('.lbp-modal__body');
    body.innerHTML = '';
    var ex = state.extras || {};

    var pv = previewVariant();
    var v = currentVariant();

    body.appendChild(renderMedia(p, pv));

    var info = el('div', 'lbp-info');

    // Badge-Leiste wie auf der PDP (sterntaler-main-product-badges: Sale, NEU, TOG, OCS, Bestickung …)
    if (ex.badges) info.appendChild(ex.badges);

    // Titel = Metafeld h1_shopify (Fallback Produkttitel), Untertitel = h2_shopify – wie auf der PDP
    var title = el('h2', 'lbp-title');
    title.id = 'lbp-title';
    var tl = el('a', null, p.title);
    tl.href = p.url;
    title.appendChild(tl);
    info.appendChild(title);
    if (p.subtitle) info.appendChild(el('p', 'lbp-subtitle', p.subtitle));

    // Preis
    var priceRow = el('div', 'lbp-price');
    var onSale = pv && pv.compare > pv.price;
    priceRow.appendChild(el('span', 'lbp-price__now' + (onSale ? ' lbp-price__now--sale' : ''), money(pv.price)));
    if (onSale) priceRow.appendChild(el('s', 'lbp-price__was', money(pv.compare)));
    info.appendChild(priceRow);

    var tax = el('p', 'lbp-tax');
    tax.textContent = (cfg().taxNote || 'inkl. MwSt.') + ' zzgl. ';
    var sl = el('a', null, 'Versand');
    sl.href = cfg().shippingUrl || '/policies/shipping-policy';
    tax.appendChild(sl);
    info.appendChild(tax);

    // Bestand (wie stock-status.liquid) – nur bei vollständig gewählter Variante
    var hasRealOptions = !(p.variants.length === 1 && /default title/i.test(p.variants[0].options[0] || ''));
    info.appendChild(renderStock(hasRealOptions ? v : p.variants[0]));

    // Bullet Points
    if (p.bullets && p.bullets.length) {
      var ul = el('ul', 'lbp-bullets');
      p.bullets.forEach(function (b) { ul.appendChild(el('li', null, b)); });
      info.appendChild(ul);
    }

    // Optionen
    if (hasRealOptions) {
      var cIdx = colorIndex(p);
      p.options.forEach(function (name, idx) {
        var values = uniqueValues(p, idx);
        var group = el('div', 'lbp-group');
        var label = el('p', 'lbp-group__label');
        label.appendChild(document.createTextNode(optionLabel(name)));
        if (state.selection[idx] != null) {
          label.appendChild(el('span', 'lbp-group__value', ': ' + state.selection[idx]));
        }
        group.appendChild(label);

        var wrap = el('div', idx === cIdx ? 'lbp-swatches' : 'lbp-pills');
        wrap.setAttribute('role', 'radiogroup');
        wrap.setAttribute('aria-label', optionLabel(name));

        values.forEach(function (val) {
          var avail = isAvailable(p, idx, val, state.selection);
          var active = state.selection[idx] === val;
          var btn = el('button', idx === cIdx ? 'lbp-swatch' : 'lbp-pill');
          btn.type = 'button';
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', active ? 'true' : 'false');
          if (active) btn.classList.add('is-active');
          if (!avail) btn.classList.add('is-unavailable');
          btn.dataset.idx = idx;
          btn.dataset.val = val;

          if (idx === cIdx) {
            var ref = p.variants.find(function (x) { return x.available && x.options[idx] === val && x.media; }) ||
                      p.variants.find(function (x) { return x.options[idx] === val && x.media; });
            var sm = swatchMedia(p, ref);
            var iw = el('span', 'lbp-swatch__img');
            if (sm) {
              var t = el('img');
              t.src = sm.thumb; t.alt = ''; t.loading = 'lazy';
              iw.appendChild(t);
            } else {
              iw.classList.add('lbp-swatch__img--empty');
            }
            btn.appendChild(iw);
            btn.appendChild(el('span', 'lbp-swatch__name', val));
          } else {
            btn.textContent = val;
          }
          if (!avail) btn.setAttribute('aria-label', val + ' – ausverkauft');
          wrap.appendChild(btn);
        });
        var isSize = optionKey(name) === 'size';
        if (isSize && ex.sizeHint) group.appendChild(ex.sizeHint);
        if (isSize && ex.chartLink) group.appendChild(ex.chartLink);
        group.appendChild(wrap);
        if (isSize && ex.guideHint) group.appendChild(ex.guideHint);
        info.appendChild(group);
      });
    }

    // Aktionen
    var actions = el('div', 'lbp-actions');
    var add = el('button', 'lbp-add');
    add.type = 'button';
    add.dataset.lbpAdd = '';
    var missing = state.selection.map(function (s, i) { return s == null ? optionLabel(p.options[i]) : null; }).filter(Boolean);

    if (state.added) {
      add.innerHTML = icon('<polyline points="20 6 9 17 4 12"/>', 15) + '<span>Im Warenkorb</span>';
      add.classList.add('is-success');
    } else if (!hasRealOptions || v) {
      var ok = hasRealOptions ? v.available : p.variants[0].available;
      add.disabled = !ok || state.loading;
      add.innerHTML = icon('<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>', 15) +
        '<span>' + (state.loading ? 'Wird hinzugefügt …' : ok ? 'In den Warenkorb' : 'Ausverkauft') + '</span>';
    } else {
      add.disabled = true;
      add.innerHTML = '<span>Bitte ' + missing.join(' & ') + ' wählen</span>';
    }
    actions.appendChild(add);

    var status = el('p', 'lbp-status');
    status.setAttribute('role', 'status');
    status.textContent = state.error || '';
    actions.appendChild(status);

    var more = el('a', 'lbp-more', 'Zum Artikel');
    more.href = p.url;
    more.insertAdjacentHTML('beforeend', icon('<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>', 14));
    actions.appendChild(more);

    info.appendChild(actions);
    body.appendChild(info);
  }

  /* ---------------- Öffnen / Schließen ---------------- */
  function open(id, trigger) {
    var node = document.getElementById(id);
    if (!node) return;
    var product;
    try { product = JSON.parse(node.textContent); } catch (e) { return; }
    product.media = product.media || [];

    buildModal();
    lastTrigger = trigger || null;

    var cIdx = colorIndex(product);
    var start = product.variants.find(function (v) { return v.id === product.selectedVariant; }) || product.variants[0];
    var selection = product.options.map(function (_, i) {
      // Farbe vorwählen (passend zum Bild), Größe bewusst offen lassen
      if (i === cIdx && start) return start.options[i];
      // Option mit nur einem Wert automatisch wählen
      var vals = uniqueValues(product, i);
      return vals.length === 1 ? vals[0] : null;
    });
    if (cIdx === -1 && product.variants.length === 1) selection = product.variants[0].options.slice();

    state = { product: product, selection: selection, activeMedia: null, loading: false, added: false, error: '', view: null, extras: null };
    render();

    var current = state;
    loadExtras(product).then(function (ex) {
      if (!ex || state !== current) return;
      state.extras = ex;
      var y = dialog.scrollTop;
      render();
      dialog.scrollTop = y;
    });

    modal.hidden = false;
    document.documentElement.classList.add('lbp-open');
    requestAnimationFrame(function () {
      modal.classList.add('is-visible');
      var c = modal.querySelector('.lbp-modal__close');
      if (c) c.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-visible');
    document.documentElement.classList.remove('lbp-open');
    setTimeout(function () {
      modal.hidden = true;
      dialog.scrollTop = 0;
      dialog.style.minHeight = '';
    }, 220);
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  /* ---------------- Warenkorb ---------------- */
  function addToCart() {
    var p = state.product;
    var v = currentVariant() || (p.variants.length === 1 ? p.variants[0] : null);
    if (!v || !v.available || state.loading) return;

    state.loading = true; state.error = ''; render();

    var cartDrawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: v.id, quantity: 1 }] };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      payload.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        state.loading = false;
        if (!res.ok || res.json.status) {
          state.error = res.json.description || res.json.message || 'Der Artikel konnte nicht hinzugefügt werden.';
          render();
          return;
        }
        // Dawn Pub/Sub (pubsub.js / constants.js sind klassische Skripte -> globale Bindings)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lookbook-popup', productVariantId: v.id, cartData: res.json }); } catch (e) {}
        }
        if (cartDrawer && res.json.sections && typeof cartDrawer.renderContents === 'function') {
          close();
          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          setTimeout(function () { cartDrawer.renderContents(res.json); }, 230);
        } else {
          state.added = true;
          render();
        }
      })
      .catch(function () {
        state.loading = false;
        state.error = 'Der Artikel konnte nicht hinzugefügt werden.';
        render();
      });
  }

  /* ---------------- Events ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lb-open]');
    if (trigger) { e.preventDefault(); open(trigger.dataset.lbOpen, trigger); return; }

    if (!modal || modal.hidden || !modal.contains(e.target)) return;

    var viewBtn = e.target.closest('[data-lbp-view]');
    if (viewBtn) {
      e.preventDefault();
      dialog.style.minHeight = dialog.offsetHeight + 'px'; // Höhe halten, kein Springen beim Umschalten
      state.view = viewBtn.getAttribute('data-lbp-view');
      render();
      var b = modal.querySelector('[data-lbp-back]');
      if (b) b.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('[data-lbp-back]')) {
      e.preventDefault();
      state.view = null;
      dialog.style.minHeight = '';
      render();
      return;
    }

    var thumb = e.target.closest('[data-lbp-media]');
    if (thumb) {
      e.preventDefault();
      state.activeMedia = +thumb.dataset.lbpMedia;
      var scroll = modal.querySelector('.lbp-thumbs');
      var sl = scroll ? scroll.scrollLeft : 0;
      render();
      var ns = modal.querySelector('.lbp-thumbs');
      if (ns) ns.scrollLeft = sl;
      var t2 = modal.querySelector('[data-lbp-media="' + state.activeMedia + '"]');
      if (t2) t2.focus({ preventScroll: true });
      return;
    }

    var opt = e.target.closest('.lbp-swatch, .lbp-pill');
    if (opt) {
      var idx = +opt.dataset.idx;
      var val = opt.dataset.val;
      var isColor = optionKey(state.product.options[idx]) === 'color';
      state.selection[idx] = state.selection[idx] === val && !isColor ? null : val;
      if (isColor) state.activeMedia = null; // neue Farbe -> deren Hauptbild zeigen
      // Wenn die Kombination nicht mehr verfügbar ist, andere (nicht gewählte) Auswahl zurücksetzen
      if (!currentVariant() || !currentVariant().available) {
        state.selection = state.selection.map(function (s, i) {
          if (i === idx || s == null) return s;
          return isAvailable(state.product, i, s, state.selection) ? s : null;
        });
      }
      state.added = false; state.error = '';
      render();
      var again = modal.querySelector('[data-idx="' + idx + '"][data-val="' + CSS.escape(val) + '"]');
      if (again) again.focus({ preventScroll: true });
      return;
    }

    if (e.target.closest('[data-lbp-add]')) { e.preventDefault(); addToCart(); }
  });

  // Extras schon beim Hovern/Antippen des Hotspots vorladen
  function prefetch(e) {
    var t = e.target.closest && e.target.closest('[data-lb-open]');
    if (!t) return;
    var node = document.getElementById(t.dataset.lbOpen);
    if (!node) return;
    try { loadExtras(JSON.parse(node.textContent)); } catch (err) {}
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') {
      if (state && state.view) { state.view = null; dialog.style.minHeight = ''; render(); return; }
      close();
      return;
    }
    if (e.key === 'Tab') {
      // einfacher Fokus-Trap
      var f = dialog.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();